export default "__VITE_ASSET__yNdup645__"